import { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const CopyReceipt = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [cashReceiptData, setCashReceiptData] = useState("");
  const [fromYear, setFromYear] = useState("");
  const [toYear, setToYear] = useState("");
  const [selectedYears, setSelectedYears] = useState(0);
  const [bookNo, setBookNo] = useState("");
  const [updateCashReceiptDetails, setUpdateCashReceiptData] = useState("");
  const [noOfCopies, setNoOfCopies] = useState("");
  const [editMode, setEditMode] = useState(false);

  const [fee, setFee] = useState("");
  const [stampFee, setStampFee] = useState("");
  const [pages, setPages] = useState("");
  const [searchType, setSearchType] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    prtname: "",
    prt2name: "",
    property_detail: "",
    s_party: "",
    f_party: "",
    deed: "",
    Regdate: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    prtname: false,
    prt2name: false,
    property_detail: false,
    s_party: false,
    f_party: false,
    deed: false,
    Regdate: false,
    bookNo: false,
    noOfCopies: false,

    pages: false,
  });
  const location = useLocation();
  const { regYear, vol, sr, typeRecpt, mod } = location.state || {};
  console.log("updateCashReceiptDetails", updateCashReceiptDetails);
  console.log("cashReceiptData", cashReceiptData);

  const { userDetails } = useSelector((state) => state.auth);

  console.log("userDetails", userDetails.dcode);

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getDate()}/${
      today.getMonth() + 1
    }/${today.getFullYear()}`;
    setCurrentDate(formattedDate);
  }, []);

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 1949 }, (_, i) => 1950 + i);
  };
  const handleChange = (e) => {
    debugger;
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
    setValidationErrors((prev) => ({
      ...prev,
      [id]: false,
    }));
  };
  //   const handleFeeCalculation = (pageCount, copies, searchType) => {
  //     debugger
  //     if (!copies, !searchType) {
  //       return;
  //     }

  //     let calculatedFee = 0;

  //     // Fee calculation logic
  //     if (searchType === "0") {
  //       calculatedFee = Math.min((pageCount * 2) * copies, 100);
  //     } else if (searchType === "1") {
  //       calculatedFee = Math.min((pageCount * 4) * copies, 200);
  //     } else if (searchType === "2") {
  //       calculatedFee = Math.min((pageCount * 6) * copies, 300);
  //     }
  // debugger
  //     // Stamp Fee Calculation
  //     const stampFee = 10 * copies;
  //     setStampFee(stampFee);

  //     setFee(calculatedFee);
  //   };

  const handleFeeCalculation = (pageCount, copies, searchType) => {
    debugger;
    if (!copies || !searchType) {
      return;
    }

    let calculatedFee = 0;

    // Fee calculation logic based on searchType
    switch (searchType) {
      case "0":
        calculatedFee = Math.min(pageCount * 2 * copies, 100);
        break;
      case "1":
        calculatedFee = Math.min(pageCount * 4 * copies, 200);
        break;
      case "2":
        calculatedFee = Math.min(pageCount * 6 * copies, 300);
        break;
      default:
        calculatedFee = 0;
    }

    // Stamp Fee Calculation
    const stampFee = 10 * copies;
    setStampFee(stampFee);

    setFee(calculatedFee);
  };

  const fetchCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/get_details_Virtual_Load_Cashreceipt_Sp/${userDetails.dcode}/${userDetails.srocode}/0/receipt_copy`
      );

      if (response.data.statusResponse.statusCode === 200) {
        setCashReceiptData(response.data.cashReceiptDetails);
        setEditMode(false);
      } else {
        setError("No data found");
      }
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const fetchUpdateCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/GetReceiptModification/${userDetails.dcode}/${userDetails.srocode}/${vol}/${sr}/${regYear}`
      );

      setUpdateCashReceiptData(response.data[0]);
      setEditMode(true);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    debugger;
    if (typeRecpt === "Copy" && mod === true) {
      fetchUpdateCashReceiptDetails();
    } else {
      fetchCashReceiptDetails();
    }
  }, [typeRecpt, mod]); // Dependency array ensures this runs when typeRecpt changes
  useEffect(() => {
    if (editMode && updateCashReceiptDetails) {
      const nakaOwnerText = updateCashReceiptDetails.nakaOwner || "";
      const parts = nakaOwnerText.split(' "बनाम " ');

      const f_party = parts[0] || ""; // First part before "बनाम"
      const remainingParts = parts[1] ? parts[1].split(" ") : [];

      const s_party = remainingParts[0] || ""; // First word after "बनाम"
      const deed = remainingParts[1] || ""; // Second word as deed
      const prt2name = remainingParts[2] || ""; // Third word as prt2name
      const pages = remainingParts[3] || ""; // Fourth word as pages

      let formattedRegDate = "2025-02-07"; // Default fallback
      if (updateCashReceiptDetails.nakaRegDate) {
        const [month, day, year] = updateCashReceiptDetails.nakaRegDate
          .split(" ")[0]
          .split("/");
        formattedRegDate = `${year}-${month.padStart(2, "0")}-${day.padStart(
          2,
          "0"
        )}`;
      }
      const formattedText = `1 ${f_party} "बनाम " 2 ${s_party} 3 ${deed} 4 ${prt2name} 5 ${pages}`;
      setFormData({
        prtname: updateCashReceiptDetails.appName || "",
        prt2name,
        property_detail: updateCashReceiptDetails.nakaVill || "",
        f_party, // Extracted from nakaOwner
        s_party, // Extracted from nakaOwner
        deed, // Extracted from nakaOwner
        Regdate: formattedRegDate,
        //  formattedText,
      });
      setBookNo(updateCashReceiptDetails.nakaBook || "");
      setFromYear(updateCashReceiptDetails.yearFrom || "");
      setToYear(updateCashReceiptDetails.yearTo || "");
      setSearchType(updateCashReceiptDetails.mode || "");
      setFee(updateCashReceiptDetails.miscFee || "");
      setStampFee(updateCashReceiptDetails.stampDuty || "");
      setNoOfCopies(updateCashReceiptDetails.nakaMode || "");
      setPages(pages);
    }
  }, [updateCashReceiptDetails, editMode]);

  const CashReceiptReportLink = (printData) => {
    debugger;
    return `${REPORT_BASE_URL}/Report/CashReceiptReports.aspx?dcode=${
      userDetails.dcode
    }&srocode=${userDetails.srocode}&vol=${printData.vol}&sr=${
      printData.sr
    }&year=${
      printData.regYear
    }&recptDate=${currentDate}&tdate=${currentDate}&mode=receipt&mode1=${"copy"}`;
  };

  const handleSave = async () => {
    const errors = {};

    if (!fee) {
      if (!searchType) {
        errors.searchType = "Please Select Receipt Type";
      } else if (!bookNo) {
        errors.bookNo = "Please Select Book No";
      } else if (!noOfCopies) {
        errors.noOfCopies = "Please Select noOfCopies";
      } else if (!pages) {
        errors.pages = "Please Fill pages";
      }
    } else if (!formData.prtname) {
      errors.prtname = "Please fill Applicant Name";
    } else if (!formData.prt2name) {
      errors.prt2name = "Please fill Applicant Address";
    } else if (!formData.property_detail) {
      errors.property_detail = "Please fill Property details";
    } else if (!formData.s_party) {
      errors.s_party = "Please fill Second Party";
    } else if (!formData.f_party) {
      errors.f_party = "Please fill First Party";
    } else if (!formData.deed) {
      errors.deed = "Please fill Type of deed";
    } else if (!formData.Regdate) {
      errors.Regdate = "Please fill Regdate";
    }

    // If there are errors, set validation state and show first error message
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(Object.values(errors)[0]); // Show only the first error
      return;
    }
    try {
      const formData2 = new FormData();
      const formattedText = `${formData.f_party} "बनाम " ${formData.s_party} ${formData.deed} ${formData.prt2name} ${pages}`;
      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_copy",
        tokenno: bookNo,
        misc_fee: fee || 100,
        code: selectedYears,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: formattedText,
        nakalregdate: formData.Regdate,
        nakalcopy: noOfCopies,
        mode: searchType,
        prtname: formData.prtname,
        prt2name: formData.prt2name,
        property_detail: formData.property_detail,
      };

      Object.keys(payload).forEach((key) => {
        formData2.append(key, payload[key]);
      });
      console.log(formData2);
      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Insert_Cashreceipt_Sp`,
        formData2,
        {
          headers: {
            "Content-Type": "application/json", // Set content type to application/json
          },
        }
      );
      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        const printData = response.data.response;

        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
        setFormData({
          prtname: "",
          prt2name: "",
          property_detail: "",
          s_party: "",
          f_party: "",
          deed: "",
          Regdate: "",
        });
        setBookNo("");
        setSearchType("");
        setFee("");
        setStampFee("");
        setNoOfCopies("");
        setPages("");
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Insert Search Receipt API:", err);
      alert("Error occurred while saving the receipt.");
      toast.error("Contact IT Cell");
    }
  };

  const handleUpdate = async () => {
    const errors = {};

    if (!fee) {
      if (!searchType) {
        errors.searchType = "Please Select Receipt Type";
      } else if (!bookNo) {
        errors.bookNo = "Please Select Book No";
      } else if (!noOfCopies) {
        errors.noOfCopies = "Please Select noOfCopies";
      } else if (!pages) {
        errors.pages = "Please Fill pages";
      }
    } else if (!formData.prtname) {
      errors.prtname = "Please fill Applicant Name";
    } else if (!formData.prt2name) {
      errors.prt2name = "Please fill Applicant Address";
    } else if (!formData.property_detail) {
      errors.property_detail = "Please fill Property details";
    } else if (!formData.s_party) {
      errors.s_party = "Please fill Second Party";
    } else if (!formData.f_party) {
      errors.f_party = "Please fill First Party";
    } else if (!formData.deed) {
      errors.deed = "Please fill Type of deed";
    } else if (!formData.Regdate) {
      errors.Regdate = "Please fill Regdate";
    }

    // If there are errors, set validation state and show first error message
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(Object.values(errors)[0]); // Show only the first error
      return;
    }
    try {
      const formData2 = new FormData();
      const formattedText = `${formData.f_party} "बनाम " ${formData.s_party} ${formData.deed} ${formData.prt2name} ${pages}`;
      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_copy",
        tokenno: bookNo,
        misc_fee: fee || 100,
        code: selectedYears,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: formattedText,
        nakalregdate: formData.Regdate,
        nakalcopy: noOfCopies,
        mode: searchType,
        prtname: formData.prtname,
        prt2name: formData.prt2name,
        vol: updateCashReceiptDetails?.vol || "",
        sr: updateCashReceiptDetails?.sr || "",
        epayment_rfee: updateCashReceiptDetails?.epayment_rfee || "",
        property_detail: formData.property_detail,
      };

      Object.keys(payload).forEach((key) => {
        formData2.append(key, payload[key]);
      });

      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Update_Cashreceipt_Sp`,
        formData2,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        const printData = response.data.response;
        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");

        // Generate the report URL
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Update Search Receipt API:", err);
      alert("Error occurred while updating the receipt.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">
      <SideMenu />
      <div className="flex-1 flex flex-col">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex flex-col md:flex-row flex-1">
          {/* Left Side */}
          <div className="flex-1 p-4">
            <div className="p-4 md:p-8 bg-gray-100 min-h-screen">
              <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
                New Receipt - Copy
              </h1>

              <div className="bg-white p-4 md:p-6 space-y-4">
                <div className="flex flex-col md:flex-row md:items-center md:space-x-6 space-y-4 md:space-y-0">
                  <div>
                    <b>Date: </b>{" "}
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.recptDate
                        : currentDate}
                    </span>
                  </div>

                  <div>
                    <b>Vol no: </b>{" "}
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.vol
                        : cashReceiptData.vol}
                    </span>
                  </div>
                  <div>
                    <b>Serial No.: </b>{" "}
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.sr
                        : cashReceiptData.sr}
                    </span>
                  </div>
                  <div>
                    <b>Application no: </b>{" "}
                    <span>
                      {editMode
                        ? updateCashReceiptDetails.appliNo
                        : cashReceiptData.applino}
                    </span>
                  </div>

                  <div>
                    <b>Fee: </b> <span>{fee}</span>
                  </div>
                </div>

                {/* Form Section */}
                <div className="space-y-4 mt-4">
                  {/* Receipt Type */}
                  <div className="flex flex-col w-full md:flex-row md:items-center md:space-x-4 space-y-4 md:space-y-0">
                    {/* Receipt Type Selection */}
                    <div className="space-y-2">
                      <span className="font-bold block text-sm">
                        Select Receipt Type:
                      </span>
                      <div className="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-4">
                        {["0", "1", "2"].map((type) => (
                          <label
                            key={type}
                            className="flex items-center space-x-2"
                          >
                            <input
                              type="radio"
                              value={type}
                              checked={searchType === type}
                              onChange={(e) => {
                                const searchType = e.target.value;
                                setSearchType(searchType);
                                debugger;
                                handleFeeCalculation(
                                  pages,
                                  noOfCopies,
                                  searchType
                                );
                              }}
                              className="w-4 h-4 border-gray-300 rounded focus:ring-blue-500"
                            />

                            <span>
                              {type === "0"
                                ? "Ordinary"
                                : type === "1"
                                ? "Urgent"
                                : "Most Urgent"}
                            </span>
                          </label>
                        ))}
                      </div>
                    </div>

                    {/* Book Number Selection */}
                    <div>
                      <label className="block font-bold mb-1 text-sm">
                        Select Book No.
                      </label>
                      <select
                        value={bookNo}
                        onChange={(e) => setBookNo(e.target.value)}
                        className={`w-full border  ${
                          validationErrors.bookNo
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500`}
                      >
                        <option value="">Select</option>
                        <option value="1">1</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="6">6</option>
                      </select>
                    </div>

                    {/* No. of Copies Selection */}
                    <div>
                      <label className="block font-bold mb-1 text-sm">
                        No. of Copies
                      </label>
                      <select
                        value={noOfCopies}
                        onChange={(e) => {
                          const copies = parseInt(e.target.value, 10) || 0;
                          handleFeeCalculation(pages, copies, searchType);
                          setNoOfCopies(copies);
                        }}
                        className={`w-full border  ${
                          validationErrors.noOfCopies
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } border-gray-300 p-2 rounded focus:ring-2 focus:ring-blue-500`}
                      >
                        <option value="">Select</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                      </select>
                    </div>

                    {/* Pages Input */}

                    <div>
                      <label className="block font-bold mb-1 text-sm">
                        Pages
                      </label>
                      <input
                        type="number"
                        value={pages}
                        onChange={(e) => {
                          const pageCount = parseInt(e.target.value, 10) || "";

                          handleFeeCalculation(
                            pageCount,
                            noOfCopies,
                            searchType
                          );
                          setPages(pageCount);
                        }}
                        className={`w-full border  ${
                          validationErrors.pages
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500`}
                      />
                    </div>
                    {/* Fee Display (Stamp) */}
                    <div>
                      <label className="block font-bold mb-1 text-sm">
                        Stamp
                      </label>
                      <input
                        type="text"
                        value={stampFee}
                        readOnly
                        className={`w-full border  ${
                          validationErrors.stampFee
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } border-gray-300 p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-100`}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  {/* Checkbox */}
                  <input
                    type="checkbox"
                    id="custom-checkbox"
                    checked={"isChecked"}
                    onChange={"handleCheckboxChange"}
                    className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                  />
                  {/* Label */}
                  <label
                    htmlFor="custom-checkbox"
                    className="text-gray-700 text-sm"
                  >
                    Computerised Record
                  </label>
                </div>
                {/* Text Inputs */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="prtname"
                        type="text"
                        value={formData.prtname}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.prtname
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="prtname"
                        className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                      >
                        Applicant Name
                      </label>
                    </div>
                  </div>
                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="prt2name"
                        type="text"
                        value={formData.prt2name}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.prt2name
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="prt2name"
                        className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                      >
                        Registration Details (Dafa 60)
                      </label>
                    </div>
                  </div>
                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="f_party"
                        value={formData.f_party}
                        onChange={handleChange}
                        type="text"
                        placeholder=""
                        className={`w-full border ${
                          validationErrors.f_party
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                      />
                      <label
                        htmlFor="f_party"
                        className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                      >
                        First Party Name
                      </label>
                    </div>
                  </div>
                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="s_party"
                        value={formData.s_party}
                        onChange={handleChange}
                        type="text"
                        placeholder=""
                        className={`w-full border ${
                          validationErrors.s_party
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                      />
                      <label
                        htmlFor="s_party"
                        className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                      >
                        Second Party Name
                      </label>
                    </div>
                  </div>
                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="deed"
                        value={formData.deed}
                        onChange={handleChange}
                        type="text"
                        placeholder=""
                        className={`w-full border ${
                          validationErrors.deed
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                      />
                      <label
                        htmlFor="deed"
                        className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                      >
                        Type Of Deed
                      </label>
                    </div>
                  </div>
                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="property_detail"
                        type="text"
                        value={formData.property_detail}
                        onChange={handleChange}
                        className={`w-full border ${
                          validationErrors.property_detail
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                        placeholder=""
                      />
                      <label
                        htmlFor="property_detail"
                        className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
                      >
                        Property Details
                      </label>
                    </div>
                  </div>
                  <div className="col-span-1 md:col-span-2">
                    <div className="relative">
                      <input
                        id="Regdate"
                        value={formData.Regdate}
                        onChange={handleChange}
                        type="Date"
                        className={`w-full border ${
                          validationErrors.Regdate
                            ? "border-[#DA0000]"
                            : "border-[#B1B1B1]"
                        } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                      />

                      <label
                        htmlFor="Regdate"
                        className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 left-3 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4"
                      >
                        Regdate
                      </label>
                    </div>
                  </div>
                  <div className="col-span-1 md:col-span-1 md:col-end-3">
                    <div className="relative">
                      <button
                        onClick={editMode ? handleUpdate : handleSave}
                        className="w-full bg-blue-400 text-white px-6 py-2 rounded hover:bg-blue-700 focus:outline-none"
                      >
                        {editMode ? "UPDATE" : "SAVE"}
                      </button>
                    </div>
                  </div>
                  <div className="col-span-1 md:col-span-1 md:col-end-4">
                    <div className="relative">
                      <button className="w-full text-[#DA0000] px-6 py-2 border border-[#DA0000] rounded hover:bg-red-100 focus:outline-none">
                        CANCEL
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyReceipt;
